import * as ActionTypes from "../actions/types";

const initialState = {
  tickets: [],
  currentTicket: null,
  loading: false,
  error: null,
  createSuccess: false,
  updateSuccess: false,
  total: 0,
};

export default function supportTicketReducer(state = initialState, action) {
  switch (action.type) {
    // Fetch tickets list
    case ActionTypes.FETCH_TICKETS:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ActionTypes.STORE_TICKETS:
      return {
        ...state,
        tickets: action.payload?.payload || [],
        total: action.payload?.payload?.length || 0,
        loading: false,
        error: null,
      };

    case ActionTypes.FETCH_TICKETS_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload?.message || "Failed to fetch support tickets",
      };

    // Fetch single ticket
    case ActionTypes.FETCH_TICKET_ID:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case ActionTypes.STORE_TICKET_ID:
      return {
        ...state,
        currentTicket: action.payload?.payload || null,
        loading: false,
        error: null,
      };

    case ActionTypes.FETCH_TICKET_ID_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload?.message || "Failed to fetch support ticket",
      };

    // Create ticket
    case ActionTypes.CREATE_TICKET:
      return {
        ...state,
        loading: true,
        error: null,
        createSuccess: false,
      };

    case ActionTypes.CREATE_TICKET_SUCCEED:
      return {
        ...state,
        loading: false,
        error: null,
        createSuccess: true,
      };

    case ActionTypes.CREATE_TICKET_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload?.message || "Failed to create support ticket",
        createSuccess: false,
      };

    // Update ticket
    case ActionTypes.UPDATE_TICKET:
      return {
        ...state,
        loading: false,
        error: null,
        updateSuccess: false,
      };

    case ActionTypes.UPDATE_TICKET_SUCCEED:
      return {
        ...state,
        loading: false,
        error: null,
        updateSuccess: true,
      };

    case ActionTypes.UPDATE_TICKET_FAILED:
      return {
        ...state,
        loading: false,
        error: action.payload?.message || "Failed to update support ticket",
        updateSuccess: false,
      };

    // Clear form
    case ActionTypes.CLEAR_TICKET_FORM:
      return {
        ...state,
        createSuccess: false,
        updateSuccess: false,
        error: null,
      };

    default:
      return state;
  }
}
